@use "../../../../../shared/scss" as *;

:host {
  .tag {
    white-space: initial;
    text-align: start;

    &:not(:last-child) {
      padding-inline-end: $pds-spacing-fluid-x-small;
    }
  }
}
